import { toast } from 'react-toastify';
import { PRICE_CHANGE_WARNING_STORAGE_KEY } from '@constants/delivery';
import { getLocalStorageItem } from '@utils/getLocalStorageItem';
import PriceChangeWarning from '.';

const PRICE_CHANGE_WARNING_TOAST_ID = 'price-change-warning';

export const showPriceChangeWarningNotification = (): void => {
  if (
    getLocalStorageItem<boolean>(PRICE_CHANGE_WARNING_STORAGE_KEY) === true ||
    toast.isActive(PRICE_CHANGE_WARNING_TOAST_ID)
  ) {
    return;
  }

  toast(
    ({ closeToast }) => (
      <PriceChangeWarning onDismiss={closeToast} className='rounded-lg' />
    ),
    {
      position: 'top-right',
      closeButton: false,
      autoClose: 5000,
      hideProgressBar: true,
      className: '!p-0 !bg-transparent w-[380px]',
      toastId: PRICE_CHANGE_WARNING_TOAST_ID
    }
  );
};
